import { Component, Input, FactoryProvider, ViewChild, ViewContainerRef, Type, AfterViewInit, OnInit, InjectionToken, Injector, StaticProvider, inject } from '@angular/core';
import { ControllerFactory } from '../../../../../../../form-controls/component-base/controller/controller.factory';
import { FormControl, AbstractControl } from '@angular/forms';

@Component({
    selector: 'controller-selector',
    templateUrl: './controller-selector.component.html',
    styleUrls: ['./controller-selector.component.scss'],
    standalone: false
})
export class ControllerSelectorComponent implements AfterViewInit, OnInit {
    controllerStrings: string[];
    formControl: AbstractControl = new FormControl(null);

    public _controllers: (FactoryProvider & { settings?: Type<any>[] })[];

    @Input()
    set controllers(val: (FactoryProvider & { settings?: Type<any>[] })[]) {
        this._controllers = val;
        this.controllerStrings = ControllerFactory.getControllerTypes(val);
    }

    @Input()
    config: any;

    @ViewChild('portal', { read: ViewContainerRef, static: true })
    public _portal: ViewContainerRef;

    constructor(
       
    ) {
        this.formControl.valueChanges.subscribe((result) => {
            if (this.config.controller.controllerName !== result) {
                this.config.controller = {};
                this.config.controller.controllerName = result;
                this._createSettings();
            }
        });
    }

    ngOnInit(): void {
        if (this.config.controller)
            this.formControl.setValue(this.config.controller.controllerName);
    }

    ngAfterViewInit() {
        this._createSettings();
    }

    public _createSettings(): void {
        this._portal.clear();
        let controller = this._controllers.find(x => x.provide['_desc'] === this.config.controller.controllerName);

        if (!controller || !controller.settings)
            return;

        if (!this.config.controller.arguments)
            this.config.controller.arguments = {};

		controller.settings.forEach(x => {
			// Use the new ViewContainerRef.createComponent API
			const injector = this._createInjector(this._portal.injector, [
				{ provide: SETTINGS_CONFIG_DATA, useValue: this.config.controller }
			]);
			const componentRef = this._portal.createComponent(x, { injector });
			componentRef.changeDetectorRef.detectChanges();
		});
    }

	public _createInjector(parent: Injector, providers: StaticProvider[]): Injector {
		return Injector.create({ providers, parent });
	}
}

export const SETTINGS_CONFIG_DATA = new InjectionToken("SETTINGS_CONFIG_DATA");